export default __webpack_public_path__ + "static/media/ic-home.4fe569d6.svg";